// Update Member Roles if BE changes
export enum MemberRoles {
  NoAccess = 'Team Member - No Access',
}
